import { ParsedUrlQuery } from 'querystring'

export const openExternalUrl = (
    domain: string,
    query: ParsedUrlQuery,
    options?: {
        utmContent?: string
        additionalParams?: Record<string, string>
    },
) => {
    const params = new URLSearchParams(query as Record<string, string>)

    if (!params.has('utm_source')) params.set('utm_source', 'blackcrow')
    if (options?.utmContent) params.set('utm_content', options.utmContent)
    if (options?.additionalParams) {
        Object.entries(options.additionalParams).forEach(([k, v]) =>
            params.set(k, v),
        )
    }

    window.open(`https://${domain}?${params}`, '_blank', 'noopener,noreferrer')
}
